import zod from 'zod';
import { stringToBoolean, stringToListOfNumber, stringToListOfEnum } from './helpers';
import { tags, DebuggerTag, subTags, DebuggerSubTag } from '../pages/app-agent/Debugger/Debugger';

const AgentOccurrencesSchema = zod.object({});
const AgentUnitsSchema = zod.object({});
const ActivitiesAndServicesSchema = zod.object({});
const ActivitiesAndServicesSchemaDetails = zod.object({
    activityId: zod.coerce.number().optional()
});
const CortexFinderSchema = zod.object({});
const PersonOfInterestSchema = zod.object({});
const AgentSignaturesSchema = zod.object({});

const AgentOccurrenceDetailsSchema = zod.object({
    occurrenceId: zod.coerce.number(),
});

const OpenVacanciesSchema = zod.object({
    textFilter: zod.string().optional(),
    tagsIds: stringToListOfNumber.optional(),
    actingBodyUnitId: zod.coerce.number().optional(),
    actingBodyCommandId: zod.coerce.number().optional(),
    workplaceId: zod.coerce.number().optional(),
    beginIn: zod.coerce.number().optional(),
    endIn: zod.coerce.number().optional(),
    showOnlyAvailableVacancies: stringToBoolean.optional(),
});

const VacancyDetailsApplySchema = zod.object({
    id: zod.coerce.number(),
});

const CandidaciesSchema = zod.object({
    textFilter: zod.string().optional(),
    beginIn: zod.coerce.number().optional(),
    endIn: zod.coerce.number().optional(),
});

const VacancyDetailsCancelSchema = zod.object({
    id: zod.coerce.number(),
});

const DebuggerSchema = zod.object({
    tags: stringToListOfEnum(
        zod.enum(Object.keys(tags) as [DebuggerTag, ...DebuggerTag[]]),
    ),
    subTags: stringToListOfEnum(
        zod.enum(Object.keys(subTags) as [DebuggerSubTag, ...DebuggerSubTag[]]),
    ),
});

const ServicesSchema = zod.object({});
const LprEventsSchema = zod.object({});

export const AppAgentSchemas = {
    AgentOccurrences: AgentOccurrencesSchema,
    AgentUnits: AgentUnitsSchema,
    ActivitiesAndServices: ActivitiesAndServicesSchema,
    ActivitiesAndServicesDetails: ActivitiesAndServicesSchemaDetails,
    CortexFinder: CortexFinderSchema,
    PersonOfInterest: PersonOfInterestSchema,
    AgentSignatures: AgentSignaturesSchema,
    AgentOccurrenceDetails: AgentOccurrenceDetailsSchema,
    OpenVacancies: OpenVacanciesSchema,
    VacancyDetailsApply: VacancyDetailsApplySchema,
    Candidacies: CandidaciesSchema,
    VacancyDetailsCancel: VacancyDetailsCancelSchema,
    Debugger: DebuggerSchema,
    Services: ServicesSchema,
    LprEvents: LprEventsSchema,
} as const;
